export default "__VITE_ASSET__USP9V0lq__"